import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-leadcenter',
  templateUrl: './leadcenter.component.html',
  styleUrls: ['./leadcenter.component.css']
})
export class LeadcenterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
